import { 
    Component, 
    ViewChild 
}                                       from "@angular/core";
import {
    Router,
    ActivatedRoute
}                                       from "@angular/router";
import { 
    FormBuilder, 
    Validators 
}                                       from "@angular/forms";
import "style-loader!./404.scss";

@Component({
  selector: "error-404",
  template: require('./404.component.html'),
})
export class Error404Component {
    constructor(
      router: Router,
      route: ActivatedRoute
      
    ) {
    }
}


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/screens/errors/404.component.ts